import { render, staticRenderFns } from "./calendar.html?vue&type=template&id=79c5e091&scoped=true&"
import script from "./calendar.js?vue&type=script&lang=js&"
export * from "./calendar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5e091",
  null
  
)

export default component.exports